
let data = {
    personaleInfo: {
        name: 'Bassel',
        surename: 'ASSI',
        email: 'bassel-assi@live.com',
        cellphone: 3201538330,
        address: 'via monte cengio, trieste'
    },
    aboutMe: {
        title: "FRONT-END DEVOLEOPER / PROCESS AND MATERIAL ENGINEER",
        profile: `Sono uno studente di magistrale in ingegneria di processo e materiali, con una grande passione e forte motivazione per diventare un sviluppatore fronte-end.
            competenza in javascript, css,html, react, Bootstrap e object-oriented-programing. Sono una
            persona seria con una grande capacità di adattamento e la voglia di imparare. Cerco la mia prima esperienza per fare partire la mia carriera.`
    },
    //    profile:'I am a process and materials engineer, i got my bachelor degree in industrial engineering, '+
    //             'then my master degree in process and material engineering both from Trieste university. During the past years i develop a interest in coding, and the intrest slowly become a passion, '+
    //             'so i decided to pursue a new carrier as programer. I taught myself how to code using the basic technology for front-end development (JAVASCRIPT, HTML, CSS, BOOTSTRAP, REACT).'+
    //             ' I am an intelligent, disciplined, responsible and hardworking person '+
    //             'with height motivation and curiosity and never ending desire of learning.',
    profile: "I am an Industrial Engineer pursuing a Master's degree in Process and Material Engineering at Trieste University.\n" +
        "My journey into the world of programming began as a personal passion, and it has since evolved into a fulfilling and rewarding career path.\n" +
        "Driven by an intrinsic fascination with technology and a desire to create impactful solutions, I embarked on a self-taught " +
        "programming journey that has become a defining aspect of my professional identity. " +
        "The thrill of turning lines of code into tangible, user-friendly experiences ignited my passion for software development," +
        " and I have been unwaveringly dedicated to expanding my skills ever since.",
    studies: [
        {
            degree: 'Laurea triennale in ingegneria industriale',
            schoole: 'Università degli studi di Trieste',
            start: '2012',
            end: '2016'
        },
        {
            degree: 'Corso magistrale in ingegneria dei processi e dei materiali',
            schoole: 'Università degli studi di Trieste',
            start: '2017',
            end: '2023'
        }
    ],
    exprience: [
        {
            postion: 'Porta pizza',
            company: 'PIZZA PARINI',
            start: '2022',
            end: 'oggi'
        },
        {
            postion: 'Cameriere',
            company: 'HOSTARIA MALCANTON',
            start: '2021',
            end: '2022'
        },
        {
            postion: 'Venditore d’ auto',
            company: 'REAUTO',
            start: '2021',
            end: '2021'
        }
    ],
    programnigSkills: [
        {
            skill: 'TYPESCRIPT',
            competence: 80,
            logo: '../imgs/java-script.png'
        },
        {
            skill: 'SVELTE',
            competence: 80,
            logo: '../imgs/svelte-icon.png'
        },
        {
            skill: 'REACT',
            competence: 75,
            logo: '../imgs/react.png'
        },
        {
            skill: 'Flutter',
            competence: 70,
            logo: '../imgs/node.png'
        },
        {
            skill: 'EXPRESSJS',
            competence: 30,
            logo: '../imgs/Expressjs.png'
        },
        {
            skill: 'NODE',
            competence: 50,
            logo: '../imgs/node.png'
        },

        {
            skill: 'tailwind',
            competence: 80,
            logo: '../imgs/bootstrap.png'
        },
        {
            skill: 'BOOTSTRAP',
            competence: 90,
            logo: '../imgs/bootstrap.png'
        },
    ],
    engineeringSkills: [
        {
            skill: 'ASPEN-PLUS',
            competence: 50,
            logo: '../imgs/aspenLogo.png'
        },
        {
            skill: 'MATLAB',
            competence: 50,
            logo: '../imgs/matalb.png'
        },
        {
            skill: 'EDU-PACK',
            competence: 70,
            logo: '../imgs/EDU-PACK.png'
        }
    ],
    softSkills: [
        {
            skill: 'PROBLEM SOLVING',
            logo: '../imgs/problem-sovling.png'
        },
        {
            skill: 'FLEXIBILITY',
            logo: '../imgs/flexibility.png'
        },
        {
            skill: 'TEAM PLAYER',
            logo: '../imgs/team-player.png'
        },
        {
            skill: 'RESPONSIVENESS',
            logo: '../imgs/responsevines.png'
        },
        {
            skill: 'ORGANIZATION',
            logo: 'imgs/organization.png'
        },

    ],
    languages: [
        {
            language: 'ITALIANO',
            level: 90
        },
        {
            language: 'INGLESE',
            level: 90
        },
        {
            language: 'ARABO',
            level: 100
        }
    ]

}


export default data
